const ACTIVE_PARTNER = "activePartner";

export default {
  ACTIVE_PARTNER,
};
